/**
 * Platform identifiers sent to the API during lead creation and registration.
 */
export const RegistrationPlatform = {
  IOS: 'ios',
  ANDROID: 'android',
  WEB: 'web',
  SHOPIFY: 'shopify',
} as const;

export type RegistrationPlatformType = (typeof RegistrationPlatform)[keyof typeof RegistrationPlatform];
